export default "__VITE_ASSET__89c7146e__"